<template>
  <div class="chart-container" :class="{ 'pie-chart': isPieChart }">
    <highcharts ref="chart" :options="chartOptions" />
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  mounted() {
    setTimeout(() => {
      if (!this.$refs.chart) return;
      this.$refs.chart.chart.redraw();
    }, 200);
  },
  computed: {
    isPieChart() {
      return this.options.chart && this.options.chart.type === "pie";
    },
    chartOptions() {
      // Start with the provided options
      let options = Object.assign({}, this.options);

      // Only apply defaults if not already specified
      const defaults = {
        credits: {
          enabled: false,
        },
        title: {
          text: "",
        },
        legend: {
          enabled: true,
        },
      };

      // Apply defaults only for properties not already set
      Object.keys(defaults).forEach((key) => {
        if (!options[key]) {
          options[key] = defaults[key];
        }
      });

      // Only apply line chart defaults if no chart type is specified
      if (!options.chart || !options.chart.type) {
        options = Object.assign({}, options, {
          chart: Object.assign(
            {
              height: 600,
              type: "line",
            },
            options.chart || {}
          ),
          xAxis: Object.assign(
            {
              type: "datetime",
            },
            options.xAxis || {}
          ),
          yAxis: Object.assign(
            {
              min: 0,
              title: {
                text: "",
              },
            },
            options.yAxis || {}
          ),
          plotOptions: Object.assign(
            {
              line: {
                dataLabels: {
                  enabled: true,
                },
              },
            },
            options.plotOptions || {}
          ),
        });
      }

      return options;
    },
  },
};
</script>

<style>
.chart-container {
  height: 600px;
}

.chart-container.pie-chart {
}
</style>
